import React from 'react'
import classes from './Preloader.module.css'

const Preloader = ({loaderTime}) => {
    return (
        <svg className={classes.main} style={{"--time": loaderTime}}viewBox="0 0 1084 599" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g className={classes.leftSide}>
                <path d="M163.565 373.841L467.111 194.109C508.469 169.621 522.145 116.243 497.656 74.8848C473.168 33.5271 419.79 19.8516 378.432 44.3397L74.8855 224.071C33.5278 248.559 19.8522 301.938 44.3403 343.296C68.8284 384.653 122.207 398.329 163.565 373.841Z" fill="#EA4335" />
                <path d="M378.431 554.02L74.8847 374.289C33.527 349.801 19.8515 296.422 44.3396 255.065C68.8277 213.707 122.206 200.031 163.564 224.519L467.111 404.251C508.468 428.739 522.144 482.118 497.656 523.475C473.168 564.833 419.789 578.509 378.431 554.02Z" fill="#4285F5" />
            </g>
            <g className={classes.rightSide}>
                <path d="M920.427 373.841L616.881 194.109C575.523 169.621 561.848 116.243 586.336 74.8848C610.824 33.5272 664.202 19.8517 705.56 44.3398L1009.11 224.071C1050.46 248.56 1064.14 301.938 1039.65 343.296C1015.16 384.653 961.785 398.329 920.427 373.841Z" fill="#0F9D58" />
                <path d="M705.561 554.02L1009.11 374.289C1050.47 349.801 1064.14 296.422 1039.65 255.065C1015.16 213.707 961.786 200.031 920.428 224.519L616.881 404.251C575.524 428.739 561.848 482.118 586.336 523.475C610.825 564.833 664.203 578.509 705.561 554.02Z" fill="#F4B400" />
            </g>
        </svg>


    )
}

export default Preloader